'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

exports.default = function (blockType) {
  return function (editorState) {
    return (0, _utils.insertCustomBlock)(editorState, blockType);
  };
};